var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000007513"
  }, /*#__PURE__*/React.createElement("g", {
    id: "visibility"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3137_52049",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 14,
    height: 14
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3137_52049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "visibility_2",
    d: "M12.3399 14.9164C13.0603 14.9164 13.6727 14.6642 14.177 14.1599C14.6814 13.6556 14.9335 13.0432 14.9335 12.3227C14.9335 11.6023 14.6814 10.9899 14.177 10.4856C13.6727 9.98125 13.0603 9.72909 12.3399 9.72909C11.6194 9.72909 11.007 9.98125 10.5027 10.4856C9.9984 10.9899 9.74624 11.6023 9.74624 12.3227C9.74624 13.0432 9.9984 13.6556 10.5027 14.1599C11.007 14.6642 11.6194 14.9164 12.3399 14.9164ZM12.3399 13.8789C11.9076 13.8789 11.5402 13.7276 11.2376 13.425C10.935 13.1224 10.7837 12.755 10.7837 12.3227C10.7837 11.8905 10.935 11.523 11.2376 11.2204C11.5402 10.9178 11.9076 10.7665 12.3399 10.7665C12.7722 10.7665 13.1396 10.9178 13.4422 11.2204C13.7448 11.523 13.8961 11.8905 13.8961 12.3227C13.8961 12.755 13.7448 13.1224 13.4422 13.425C13.1396 13.7276 12.7722 13.8789 12.3399 13.8789ZM12.3399 16.6455C10.9374 16.6455 9.65979 16.254 8.50706 15.4711C7.35433 14.6882 6.51861 13.6388 5.99988 12.3227C6.51861 11.0067 7.35433 9.95723 8.50706 9.17434C9.65979 8.39145 10.9374 8 12.3399 8C13.7424 8 15.02 8.39145 16.1727 9.17434C17.3254 9.95723 18.1611 11.0067 18.6799 12.3227C18.1611 13.6388 17.3254 14.6882 16.1727 15.4711C15.02 16.254 13.7424 16.6455 12.3399 16.6455Z",
    fill: "#4CAF50"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailOpen);
export default __webpack_public_path__ + "static/media/email_open.2444a7b8abf2884837ae33c08c5ef488.svg";
export { ForwardRef as ReactComponent };